<template>
  <div>
    <div class="question-main-tab">
      <ul class="main-tab">
        <li v-for="(item,index) in questionCategorys" :class="{active:index == cur_cate_key}" @click="selectQuestionCate(index)">{{item.title}}</li>
      </ul>
    </div>

    <div class="member-main-body">
      <div class="course-box">
        <div class="c-list" :class="{active:item.id == cur_bankId}" v-for="(item,index) in banks" @click="selectBank(item.id)">{{item.title}}</div>
      </div>
      <div class="practice-nodata" v-if="!questionLoaded">
        <img src="../../assets/nodata-03.png" alt="no-data" />
        <p>暂无题目收藏</p>
      </div>
      <div class="collect-body" v-else>
        <div class="type-box" v-for="(item, index) in bankTypeList" >
          <div class="type-title">{{item.title}}</div>
          <div class="type-bottom">
            <div class="collect-count">收藏数：{{item.collectCount}}</div>
            <div class="show-btn">
              <router-link
                :to="{ name: 'FavExercise', params: {bankId:cur_bankId, typeId: item.id} }"
                taget="_blank"
              ><Button type="primary" shape="circle" long>查看收藏</Button></router-link>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getCourseQuestion, getQuestionsCollect } from "../../api/api";
export default {
  data() {
    return {
      questionCategorys: [],
      cur_cate_key: 0,
      banks: [],
      bankTypeList: [],
      questionLoaded: false,
      cur_bankId: 0,
      paramsBankId: 0
    };
  },
  created() {
    if(this.$route.params.bankId){
      this.paramsBankId = this.$route.params.bankId
    }
    this.getCourseQuestion();
  },
  methods: {
    getCourseQuestion(){
      var _this = this;
      getCourseQuestion().then(res => {
        if(res.code == 1){
          _this.questionCategorys = res.data
          _this.setCurrent()
        }
      })
    },

    setCurrent(){
      var _this = this;
      if(this.paramsBankId){
        this.questionCategorys.forEach(function(v,i){
          v.child.forEach(function(vv,ii){
            if(vv.id == _this.paramsBankId){
              _this.cur_cate_key = i
              _this.selectQuestionCate(i, ii)
            }
          })
        })
      }else{
        this.cur_cate_key = 0
        this.selectQuestionCate(0,0)
      }
    },

    selectQuestionCate(key,ckey){
      this.cur_cate_key = key;
      this.banks = this.questionCategorys[key].child;
      this.cur_bankId = this.banks[ckey].id;
      this.selectBank(this.cur_bankId)
    },

    selectBank(bank_id){
      this.cur_bankId = bank_id
      this.bankTypeList = [];
      this.getQuestionsCollect(bank_id)
    },

    getQuestionsCollect(bank_id){
      getQuestionsCollect({bank_id:bank_id}).then((res) => {
        if(res.code == 1){
          this.bankTypeList = res.data
          if(this.bankTypeList.length > 0){
            this.questionLoaded = true
          }else{
            this.questionLoaded = false
          }
        }
      })
    }
  },
};
</script>


<style>
  .question-main-tab {
    width: 100%;
    height: auto;
    min-height: 60px;
    background: #fff;
    border-radius: 6px;
    margin-bottom: 20px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
  }

  .question-main-tab .main-tab {
    display: block;
    padding: 10px 20px;
    overflow: hidden;
  }

  .question-main-tab .main-tab li {
    position: relative;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    color: #666;
    padding: 0 10px;
    margin-right: 40px;
    float: left;
  }

  .question-main-tab .main-tab li:hover {
    color: #333
  }

  .question-main-tab .main-tab li.active {
    font-weight: 700;
    color: #333
  }

  .question-main-tab .main-tab li.active:after {
    position: absolute;
    content: " ";
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb);
    width: 20px;
    height: 4px;
    border-radius: 10px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%)
  }

  .member-main-body {
    position: relative;
    width: 100%;
    background: #fff;
    border-radius: 6px;
    min-height: 560px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1)
  }

  .member-main-body .main-header {
    width: 100%;
    background: #f5f5f5;
    height: 60px;
    padding: 0 30px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px
  }

  .member-main-body .no-data {
    padding-top: 100px;
    text-align: center
  }

  .member-main-body .no-data img {
    margin: 0 auto
  }

  .member-main-body .no-data p {
    font-size: 16px;
    color: #666
  }

  .member-main-body .main-table {
    position: relative;
    width: 100%;
    padding: 0 30px
  }

  .member-main-body .main-table.scroll-top {
    margin-top: -60px
  }

  .member-main-body .main-table table {
    width: 100%
  }

  .member-main-body .main-table table thead th {
    height: 60px;
    color: #999
  }

  .member-main-body .main-table table td,
  .member-main-body .main-table table th {
    text-align: left
  }

  .member-main-body .main-table table td.center,
  .member-main-body .main-table table th.center {
    text-align: center
  }

  .member-main-body .main-table table td.right,
  .member-main-body .main-table table th.right {
    text-align: right
  }

  .member-main-body .main-table table td {
    padding: 12px 0;
    border-bottom: 1px dashed #ccc;
    line-height: 20px;
    color: #666
  }

  .member-main-body .main-table table td .ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden
  }

  .course-search {
    margin: 14px 30px 0 0
  }

  .course-search .ivu-input {
    background: #f2f2f2;
    border-radius: 20px;
    padding-left: 12px
  }

  .course-list {
    padding: 20px 30px
  }

  .course-list li {
    border-bottom: 1px dashed #ccc;
    display: flex;
    align-items: center;
    padding: 10px 0
  }

  .course-list li .course-name {
    flex: 1;
    font-size: 16px
  }

  .course-list li .course-btn {
    width: 100px
  }

  .course-fa{
    padding: 20px 20px 0 20px;
  }
  .course-fa .course-title{
    font-size: 18px;
    font-weight: bold;
  }
  .course-fa .course-matter{
    font-size:16px;
    margin-left:20px;
    color:red;
    margin-top:3px;
  }
  .course-fa .course-matter span{
    color:#000;
  }

  .course-box{
    padding: 30px;
    overflow: hidden;
  }
  .course-box .c-list{
    border: 1px solid #ccc;
    border-radius: 20px;
    padding: 2px 15px;
    margin-right: 20px;
    margin-bottom: 10px;
    float: left;
    font-size: 16px;
    cursor: pointer;
  }
  .course-box .c-list.active{
    border: 1px solid #41a1fc;
    color: #fff;
    background: #41a1fc;
  }
  .practice-nodata {
    padding: 35px;
    text-align: center;
  }
  .practice-nodata  img {
    margin: 0 auto;
  }

  .practice-nodata p {
    margin-top: 16px;
    text-align: center;
    font-size: 18px;
  }

  .study-module {
    position: relative;
    margin: 0 auto 30px auto;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
    padding: 20px 30px
  }

  .product-info-bar {
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: url(../../assets/product-detail-title.png) no-repeat 0;
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    text-indent: 1em;
    margin-bottom: 20px;
  }

  .collect-body{
    display: flex;
    flex-wrap: wrap;
    padding: 0 30px;
    justify-content: space-between;
  }

  .collect-body .type-box{
    width: 450px;
    border-radius: 10px;
    background: #F7FBFE;
    padding: 20px;
    margin-bottom: 20px;
  }

  .collect-body .type-box .type-title{
    font-size: 18px;
    font-weight: bold;
  }

  .collect-body .type-box .type-bottom{
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    font-size: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/member/collect.vue